'use client'

import { useNavigate } from 'react-router-dom'
import { useMatch } from '../hooks/useFootball'
import { useT } from '../contexts/LocaleContext'
import DreamTeamBuilder from '../components/football/DreamTeamBuilder'

export default function DreamTeamBuilderPage({ matchId }: { matchId: number }) {
  const navigate = useNavigate()
  const t = useT()
  const { data, isLoading, error } = useMatch(matchId)
  const match = data?.match

  if (isLoading) {
    return (
      <div className="lucky-fb mini-app-container pb-24 min-h-screen flex items-center justify-center">
        <div className="lucky-fb__empty">{t('common.loading')}</div>
      </div>
    )
  }

  if (error || !match) {
    return (
      <div className="lucky-fb mini-app-container pb-24 min-h-screen">
        <div className="lucky-fb__inner">
          <div className="lucky-fb__card lucky-fb__empty">{t('dreamTeam.builderPage.matchNotFound')}</div>
          <button type="button" className="lucky-fb__cta" onClick={() => navigate('/football')}>
            {t('dreamTeam.builderPage.backToFootball')}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="lucky-fb mini-app-container pb-28 min-h-screen">
      <div className="lucky-fb__inner">
        <header className="lucky-fb__header">
          <button
            type="button"
            className="lucky-wallet__back"
            onClick={() => navigate('/football')}
            aria-label={t('common.back')}
          >
            →
          </button>
          <div>
            <h1>{t('dreamTeam.title')}</h1>
            <p>{t('dreamTeam.matchVs', { home: match.home_team, away: match.away_team })}</p>
          </div>
        </header>

        <DreamTeamBuilder match={match} />
      </div>
    </div>
  )
}
